import { useState } from "react";
import { DEFAULT_FILTER_COMMISSIONS_BATCH_OUTPUTS_QUERY_PARAMS } from "../api";
import { CommissionsBatch, CommissionsBatchOutputFilterPageRequest } from "../types";
import { CommissionBatchOutputsFilterForm } from "./forms/filter/CommissionBatchOutputsFilterForm";
import { CommissionsBatchOutputsTable } from "./tables/CommissionsBatchOutputsTable";

type Props = {
  batch: CommissionsBatch;
};

export const CommissionsBatchOutputs = ({ batch }: Props) => {
  const [outputsFilterData, setOutputsFilterData] = useState<CommissionsBatchOutputFilterPageRequest>(
    DEFAULT_FILTER_COMMISSIONS_BATCH_OUTPUTS_QUERY_PARAMS,
  );

  return (
    <>
      <CommissionBatchOutputsFilterForm filterData={outputsFilterData} onChangeFilter={setOutputsFilterData} />

      <CommissionsBatchOutputsTable
        batch={batch}
        filterData={outputsFilterData}
        onChangeFilter={setOutputsFilterData}
      />
    </>
  );
};
